// src/utils/buyerLeadStages.js
// Pure, Firebase-free: the buyer pipeline's stages, colors, and label maps.

export const BUYER_STAGE_ORDER = [
  "New Lead",
  "Nurturing",
  "Consultation",
  "Pre-Approved",
  "Actively Showing",
  "Offer Submitted",
];

// Stages were renamed (Contacted → Nurturing, Offer Out → Offer Submitted).
// Existing lead records may still carry the old string, so normalize on read
// to keep them in the right column without a risky bulk DB rewrite.
const STAGE_ALIASES = {
  Contacted: "Nurturing",
  "Offer Out": "Offer Submitted",
};

export const normalizeStage = (stage) => STAGE_ALIASES[stage] || stage;

export const TIMELINE_LABELS = {
  asap: "Buying ASAP",
  "30": "Buying in ~30 days",
  "60": "Buying in ~60 days",
  "90": "Buying in ~90 days",
  "6mo_plus": "Buying in 6+ months",
};

export const PRE_APPROVAL_LABELS = {
  yes: "Pre-approved",
  in_progress: "Pre-approval in progress",
  no: "Not yet pre-approved",
};

export const PROPERTY_TYPE_OPTIONS = [
  "Single-Family",
  "Condo",
  "Townhouse",
  "Multi-Family",
  "Land",
];

export const FINANCING_OPTIONS = ["Conventional", "FHA", "VA", "Cash"];

const STAGE_COLORS = {
  "New Lead": "bg-slate-400",
  Nurturing: "bg-blue-400",
  Consultation: "bg-indigo-400",
  "Pre-Approved": "bg-violet-500",
  "Actively Showing": "bg-amber-500",
  "Offer Submitted": "bg-emerald-500",
};

export const getBuyerStageColor = (stage) =>
  STAGE_COLORS[stage] || "bg-slate-300";

export const isActiveLead = (lead) =>
  lead?.status === "active" && !(Number(lead?.deletedAt) > 0);
